import { gql } from '@apollo/client'
import { EHR_APPOINTMENT_FIELDS } from './ehrAppointment'

export const EHR_APPOINTMENT_SCHEDULING_INFO_FIELDS = gql`
  ${EHR_APPOINTMENT_FIELDS}
  fragment EhrAppointmentSchedulingInfoFields on EhrAppointmentSchedulingInfo {
    bookingAvailable
    title
    chargeKind
    schedulingMode
    pendingAppointment {
      ...EhrAppointmentFields
    }
    options {
      duration
      appointmentKind
      recurring
      product {
        id
        key
        price
        title
        details
        description
        shortDescription
        icon
        ehrSchedulingRule {
          appointmentKind
          chargeKind
          count
          key
        }
      }
      payAsYouGoProduct {
        id
        key
        price
        title
        details
        description
        shortDescription
        icon
        ehrSchedulingRule {
          appointmentKind
          chargeKind
          count
          key
        }
      }
    }
    cadenceOptions {
      key
      label
    }
  }
`
